import styled from 'styled-components';

export const SContentContainer = styled.div`
  width: 444px;
`;
